import * as axios from "axios";

export const LOAD_VARIATIONS = "/service/load_variations";
export const LOAD_PRICINGS = "/service/load_pricings";
export const LOAD_COMPLETED_VARIATIONS = "/service/load_completed_variations";

export function getVariations() {
  return function(dispatch) {
    return axios
      .get(
        "/my_client/variations.json?add_on_variation_connections=true&initial_followup_details=true&variation_setting=true",
      )
      .then((res) => {
        dispatch({
          type: LOAD_VARIATIONS,
          data: res.data,
        });
        return Promise.resolve(true);
      })
      .catch((error) => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function getPricings(locationId) {
  return function(dispatch) {
    return axios
      .get(`/my_client/pricings.json?location_ids=${locationId}`)
      .then((res) => {
        dispatch({ type: LOAD_PRICINGS, data: res.data });
        return Promise.resolve(true);
      })
      .catch((error) => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function getCompletedVariations(companyId, clientId, variationIds) {
  return function(dispatch) {
    const variationIdsEncoded = encodeURIComponent(variationIds?.join(","));
    const url = `api/mkp/v1/user/variations/check_completion?variation_ids=${variationIdsEncoded}&company_id=${companyId}&client_id=${clientId}`;

    return axios
      .get(url)
      .then((res) => {
        const completedVariations = Object.keys(
          res.data?.completed_variations || {},
        )?.reduce((acc, key) => {
          if (res.data?.completed_variations[key]) {
            acc.push(Number(key));
          }
          return acc;
        }, []);
        dispatch({
          type: LOAD_COMPLETED_VARIATIONS,
          data: completedVariations,
        });
        return Promise.resolve(true);
      })
      .catch((error) => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}
